import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-maintenance',
  templateUrl: './maintenanceGL.component.html',
  styleUrls: ['./maintenanceGL.component.scss']
})
export class MaintenanceComponentGroupLeader  {

  constructor() { }

  ngOnInit(): void {
  }
}
